import { ICompositionGroup, ICompositionGroupItemList, ICompositionGroupList } from "../types/Product";

function getCompositionPriceType(compositionGroupInfo: ICompositionGroupList | undefined): "max" | "average" | "sum" {
  if (compositionGroupInfo === undefined) {
    return "sum";
  }

  if (compositionGroupInfo.calc_type_avg) {
    return "average";
  }

  if (compositionGroupInfo.calc_type_max) {
    return "max";
  }

  return "sum";
}

/**
 * Aqui, está criando, então tem um local com as informações de produto vindo do backend, e outro local com as
 * compositions selecionadas etc
 *
 * Calcula o preço de produto com sabores (composition),
 * considerando o tipo de cálculo definido para cada grupo de sabores
 */
function getPriceCompositionOnCreating(formikCompositionGroupItemList: ICompositionGroupItemList[], formikCompositionGroupInfo: ICompositionGroupList[] | undefined): number {
  // é composição?
  if (formikCompositionGroupItemList === undefined || formikCompositionGroupItemList.length === 0) {
    return 0;
  }

  const compositionTempPrice: Array<{ id: number, type: "max" | "average" | "sum", prices: Array<number> }> = [];

  for (let i = 0; i < formikCompositionGroupItemList.length; i++) {
    const item = formikCompositionGroupItemList[i];

    if (item.quantity < 1) continue;

    const compositionGroupId = item.product_composition_id;
    const compositionGroupInfo = formikCompositionGroupInfo?.find(
      (category) => category.id === compositionGroupId,
    );

    let tempPriceForThisGroup = compositionTempPrice.find((item) => item.id === compositionGroupId);

    if (tempPriceForThisGroup === undefined) {
      tempPriceForThisGroup = {
        id: compositionGroupId,
        type: getCompositionPriceType(compositionGroupInfo),
        prices: [],
      };
      compositionTempPrice.push(tempPriceForThisGroup);
    }

    tempPriceForThisGroup.prices.push(item.quantity * item.price);
  }

  return sumAllCompositions(compositionTempPrice);
}

/**
 * Aqui, tem só o produto sendo editado, então tem só uma fonte com as infos dos compositions etc
 *
 * Calcula o preço de produto com sabores (composition),
 * considerando o tipo de cálculo definido para cada grupo de sabores
 */
function getPriceCompositionOnEditing(formikCompositionGroups: ICompositionGroup[] | undefined): number {
// é composição?
  if (formikCompositionGroups === undefined || formikCompositionGroups.length === 0) {
    return 0;
  }

  const compositionTempPrice: Array<{ id: number, type: "max" | "average" | "sum", prices: Array<number> }> = [];

  for (let i = 0; i < formikCompositionGroups.length; i++) {
    const grupo = formikCompositionGroups[i];

    if (grupo.compositionGroupItems === undefined || grupo.compositionGroupItems.length === 0) continue;

    for (let j = 0; j < grupo.compositionGroupItems.length; j++) {
      const item = grupo.compositionGroupItems[j];

      if (item.quantity < 1) continue;

      const compositionGroupInfo = grupo.compositionGroupInfo;
      const compositionGroupId = compositionGroupInfo?.id ?? -1;

      let tempPriceForThisGroup =
        compositionTempPrice.find((item) => item.id === compositionGroupId);

      if (tempPriceForThisGroup === undefined) {
        tempPriceForThisGroup = {
          id: compositionGroupId,
          type: getCompositionPriceType(compositionGroupInfo),
          prices: [],
        };
        compositionTempPrice.push(tempPriceForThisGroup);
      }

      tempPriceForThisGroup.prices.push(item.quantity * item.price);
    }
  }

  return sumAllCompositions(compositionTempPrice);
}

const sumAllCompositions = (compositionTempPrice: Array<{
  id: number,
  type: "max" | "average" | "sum",
  prices: Array<number>
}>) => {
  return compositionTempPrice.reduce((accumulator, obj) => {
    switch (obj.type) {
      case "sum":
        return accumulator + obj.prices.reduce((sum, prices) => sum + prices, 0);
      case "average":
        return accumulator + obj.prices.reduce((sum, prices) => sum + prices, 0) / obj.prices.length;
      case "max":
        return accumulator + Math.max(...obj.prices);
      default:
        return accumulator;
    }
  }, 0);
};

export { getPriceCompositionOnCreating, getPriceCompositionOnEditing };